import { createAction } from 'redux-actions';
import * as actionTypes from './gantt-constants';

export const setLanesInfo = createAction(actionTypes.SET_LANES_INFO);
export const setLaneInfo = createAction(actionTypes.SET_LANE_INFO);
export const setLaneInfoIsDraggingOver = createAction(actionTypes.SET_LANE_INFO_IS_DRAGGING_OVER);

export const setLanesData = createAction(actionTypes.SET_LANES_DATA);
export const setLaneData = createAction(actionTypes.SET_LANE_DATA);
export const addLaneData = createAction(actionTypes.ADD_LANE_DATA);
export const deleteLaneData = createAction(actionTypes.DELETE_LANE_DATA);

export const setGanttDimensions = createAction(actionTypes.SET_GANTT_DIMENSIONS);
export const setViewDimensions = createAction(actionTypes.SET_VIEW_DIMENSIONS);
export const setView = createAction(actionTypes.SET_VIEW);
export const setViewInternal = createAction(actionTypes.SET_VIEW_INTERNAL);
export const setDateReference = createAction(actionTypes.SET_DATE_REFERENCE);
export const setViewWorkingDays = createAction(actionTypes.SET_VIEW_WORKING_DAYS);

export const fetchBoardData = createAction(actionTypes.FETCH_BOARD_DATA);
export const fetchBoardDataSuccess = createAction(actionTypes.FETCH_BOARD_DATA_SUCCESS);
export const fetchBoardDataFailure = createAction(actionTypes.FETCH_BOARD_DATA_FAILURE);
export const resetBoardData = createAction(actionTypes.RESET_BOARD_DATA);

export const fetchViewData = createAction(actionTypes.FETCH_VIEW_DATA);
export const fetchViewDataSuccess = createAction(actionTypes.FETCH_VIEW_DATA_SUCCESS);
export const fetchViewDataFailure = createAction(actionTypes.FETCH_VIEW_DATA_FAILURE);

export const updateBlockData = createAction(actionTypes.UPDATE_BLOCK_DATA);
export const updateBlockDataSuccess = createAction(actionTypes.UPDATE_BLOCK_DATA_SUCCESS);
export const updateBlockOtherLaneDataSuccess = createAction(
  actionTypes.UPDATE_BLOCK_OTHER_LANE_DATA_SUCCESS,
);
export const updateBlockDataFailure = createAction(actionTypes.UPDATE_BLOCK_DATA_FAILURE);

export const fetchBlockData = createAction(actionTypes.FETCH_BLOCK_DATA);
export const fetchBlockDataSuccess = createAction(actionTypes.FETCH_BLOCK_DATA_SUCCESS);
export const fetchBlockDataFailure = createAction(actionTypes.FETCH_BLOCK_DATA_FAILURE);

export const fetchForwardBlocksData = createAction(actionTypes.FETCH_FORWARD_BLOCKS_DATA);
export const fetchForwardBlockData = createAction(actionTypes.FETCH_FORWARD_BLOCK_DATA);
export const fetchForwardBlockDataSuccess =
  createAction(actionTypes.FETCH_FORWARD_BLOCK_DATA_SUCCESS);
export const fetchForwardBlockDataFailure =
  createAction(actionTypes.FETCH_FORWARD_BLOCK_DATA_FAILURE);

export const publishToSAP = createAction(actionTypes.PUBLISH_TO_SAP);
export const publishToSAPSuccess = createAction(actionTypes.PUBLISH_TO_SAP_SUCCESS);
export const publishToSAPFailure = createAction(actionTypes.PUBLISH_TO_SAP_FAILURE);

export const publishAllToSAP = createAction(actionTypes.PUBLISH_ALL_TO_SAP);
export const publishAllToSAPSuccess = createAction(actionTypes.PUBLISH_ALL_TO_SAP_SUCCESS);
export const publishAllToSAPFailure = createAction(actionTypes.PUBLISH_ALL_TO_SAP_FAILURE);

export const markDateConfirmed = createAction(actionTypes.MARK_DATE_CONFIRMED);
export const markDateConfirmedSuccess = createAction(actionTypes.MARK_DATE_CONFIRMED_SUCCESS);
export const markDateConfirmedFailure = createAction(actionTypes.MARK_DATE_CONFIRMED_FAILURE);

export const markDateUnconfirmed = createAction(actionTypes.MARK_DATE_UNCONFIRMED);
export const markDateUnconfirmedSuccess = createAction(actionTypes.MARK_DATE_UNCONFIRMED_SUCCESS);
export const markDateUnconfirmedFailure = createAction(actionTypes.MARK_DATE_UNCONFIRMED_FAILURE);

export const restoreBackup = createAction(actionTypes.RESTORE_BACKUP);
export const restoreBackupSuccess = createAction(actionTypes.RESTORE_BACKUP_SUCCESS);
export const restoreBackupFailure = createAction(actionTypes.RESTORE_BACKUP_FAILURE);

export const splitBlock = createAction(actionTypes.SPLIT_BLOCK);
export const splitBlockSuccess = createAction(actionTypes.SPLIT_BLOCK_SUCCESS);
export const splitBlockFailure = createAction(actionTypes.SPLIT_BLOCK_FAILURE);

export const addBlockData = createAction(actionTypes.ADD_BLOCK_DATA);
export const addBlockDataSuccess = createAction(actionTypes.ADD_BLOCK_DATA_SUCCESS);
export const addBlockDataFailure = createAction(actionTypes.ADD_BLOCK_DATA_FAILURE);

export const addMultiBlockData = createAction(actionTypes.ADD_MULTI_BLOCK_DATA);
export const addMultiBlockDataSuccess = createAction(actionTypes.ADD_MULTI_BLOCK_DATA_SUCCESS);
export const addMultiBlockDataFailure = createAction(actionTypes.ADD_MULTI_BLOCK_DATA_FAILURE);

export const updateMultiPlanningBlockData =
  createAction(actionTypes.UPDATE_MULTI_PLANNING_BLOCK_DATA);
export const updateMultiPlanningBlockDataSuccess =
  createAction(actionTypes.UPDATE_MULTI_PLANNING_BLOCK_DATA_SUCCESS);
export const updateMultiPlanningBlockDataFailure =
  createAction(actionTypes.UPDATE_MULTI_PLANNING_BLOCK_DATA_FAILURE);

export const deletePlanning = createAction(actionTypes.DELETE_BLOCK);
export const deletePlanningSuccess = createAction(actionTypes.DELETE_BLOCK_SUCCESS);
export const deletePlanningFailure = createAction(actionTypes.DELETE_BLOCK_FAILURE);
export const deletePreview = createAction(actionTypes.DELETE_PREVIEW);

export const updateFilters = createAction(actionTypes.UPDATE_GANTT_FILTERS);

export const setCurrentPage = createAction(actionTypes.SET_CURRENT_PAGE);

export const setIsDraggingOver = createAction(actionTypes.SET_IS_DRAGGING_OVER);

export const updateBlockId = createAction(actionTypes.UPDATE_BLOCK_ID);
export const updateBlockOperationInfo = createAction(actionTypes.UPDATE_BLOCK_OPERATION_INFO);

export const openPlanningAndView = createAction(actionTypes.OPEN_PLANNING_AND_VIEW);
export const openPlanningAndViewSuccess = createAction(actionTypes.OPEN_PLANNING_AND_VIEW_SUCCESS);
export const openPlanningAndViewFailure = createAction(actionTypes.OPEN_PLANNING_AND_VIEW_FAILURE);
export const resetOpenPlanningAndView = createAction(actionTypes.RESET_OPEN_PLANNING_AND_VIEW);

export const fetchPublishAllCount = createAction(actionTypes.FETCH_PUBLISH_ALL_COUNT);
export const fetchPublishAllCountSuccess = createAction(
  actionTypes.FETCH_PUBLISH_ALL_COUNT_SUCCESS,
);
export const fetchPublishAllCountFailure = createAction(
  actionTypes.FETCH_PUBLISH_ALL_COUNT_FAILURE,
);
export const getGanttViews = createAction(actionTypes.GET_GANTT_VIEWS_REQUEST);
export const getGanttViewsSuccess = createAction(actionTypes.GET_GANTT_VIEWS_SUCCESS);
export const getGanttViewsFailure = createAction(actionTypes.GET_GANTT_VIEWS_FAILURE);

export const createGanttView = createAction(actionTypes.CREATE_GANTT_VIEW_REQUEST);
export const createGanttViewSuccess = createAction(actionTypes.CREATE_GANTT_VIEW_SUCCESS);
export const createGanttViewFailure = createAction(actionTypes.CREATE_GANTT_VIEW_FAILURE);

export const updateGanttViews = createAction(actionTypes.UPDATE_GANTT_VIEWS_REQUEST);
export const updateGanttViewsSuccess = createAction(actionTypes.UPDATE_GANTT_VIEWS_SUCCESS);
export const updateGanttViewsFailure = createAction(actionTypes.UPDATE_GANTT_VIEWS_FAILURE);

export const updateSort = createAction(actionTypes.UPDATE_GANTT_SORT);
export const updateView = createAction(actionTypes.UPDATE_GANTT_VIEW);

export const setBlockPreview = createAction(actionTypes.SET_BLOCK_PREVIEW);
export const setBlockPreviewFailure = createAction(actionTypes.SET_BLOCK_PREVIEW_FAILURE);

export const resetBlockData = createAction(actionTypes.RESET_BLOCK_DATA);

export const setAdjacentBlock = createAction(actionTypes.SET_ADJACENT_BLOCK);
export const clearLanesData = createAction(actionTypes.CLEAR_LANES_DATA);

export const fetchBoardMetaData = createAction(actionTypes.FETCH_BOARD_METADATA);
export const fetchBoardMetaDataSuccess =
  createAction(actionTypes.FETCH_BOARD_METADATA_SUCCESS);
export const fetchBoardMetaDataFailure =
  createAction(actionTypes.FETCH_BOARD_METADATA_FAILURE);

export const setAllTechnicians = createAction(actionTypes.SET_ALL_TECHNICIANS);

export const shouldFetchLaneData = createAction(actionTypes.SHOULD_FETCH_LANE_DATA);

export const shouldForceFetchGanttData = createAction(actionTypes.SHOULD_FORCE_FETCH_GANTT_DATA);

export const refetchLaneDataFor = createAction(actionTypes.REFETCH_LANE_DATA_FOR);

export const setLanesInfoLocally = createAction(actionTypes.SET_LANES_INFO_LOCALLY);

export const resetGanttLaneToFetch =
  createAction(actionTypes.RESET_GANTT_LANE_TO_FETCH);

export const recalculateTravelTime = createAction(actionTypes.RECALCULATE_TRAVEL_TIME);
export const recalculateTravelTimeSuccess =
  createAction(actionTypes.RECALCULATE_TRAVEL_TIME_SUCCESS);
export const recalculateTravelTimeFailure =
  createAction(actionTypes.RECALCULATE_TRAVEL_TIME_FAILURE);

export const fetchRecommendedEngineers =
  createAction(actionTypes.FETCH_RECOMMENDED_ENGINEERS);
export const fetchRecommendedEngineersSuccess =
  createAction(actionTypes.FETCH_RECOMMENDED_ENGINEERS_SUCCESS);
export const fetchRecommendedEngineersFailure =
  createAction(actionTypes.FETCH_RECOMMENDED_ENGINEERS_FAILURE);

export const calculateRouteOptimisation = createAction(actionTypes.CALCULATE_ROUTE_OPTIMISATION);
export const calculateRouteOptimisationSuccess =
  createAction(actionTypes.CALCULATE_ROUTE_OPTIMISATION_SUCCESS);
export const calculateRouteOptimisationFailure =
  createAction(actionTypes.CALCULATE_ROUTE_OPTIMISATION_FAILURE);

export const abortRouteOptimisation = createAction(actionTypes.ABORT_ROUTE_OPTIMISATION);
export const abortRouteOptimisationSuccess =
  createAction(actionTypes.ABORT_ROUTE_OPTIMISATION_SUCCESS);
export const abortRouteOptimisationFailure =
  createAction(actionTypes.ABORT_ROUTE_OPTIMISATION_FAILURE);

export const retryRouteOptimisation = createAction(actionTypes.RETRY_ROUTE_OPTIMISATION);
export const retryRouteOptimisationSuccess =
  createAction(actionTypes.RETRY_ROUTE_OPTIMISATION_SUCCESS);
export const retryRouteOptimisationFailure =
  createAction(actionTypes.RETRY_ROUTE_OPTIMISATION_FAILURE);

export const forwardPlanningUpdated = createAction(actionTypes.FORWARD_PLANNING_UPDATED);
export const forwardPlanningPlanned = createAction(actionTypes.FORWARD_PLANNING_PLANNED);

export const fetchPlanningDataPostSocketUpdate =
  createAction(actionTypes.FETCH_PLANNING_DATA_POST_SOCKET_UPDATE);
export const fetchPlanningDataPostSocketUpdateSuccess =
  createAction(actionTypes.FETCH_PLANNING_DATA_POST_SOCKET_UPDATE_SUCCESS);
export const fetchPlanningDataPostSocketUpdateFailure =
  createAction(actionTypes.FETCH_PLANNING_DATA_POST_SOCKET_UPDATE_FAILURE);

export const deletePlanningDataPostSocket =
  createAction(actionTypes.DELETE_PLANNING_DATA_POST_SOCKET);

export const resetSocketState = createAction(actionTypes.RESET_SOCKET_STATE);

export const updateDataFromSockets = createAction(actionTypes.UPDATE_DATA_FROM_SOCKETS);
